const indexItems = [
  { title: '娱乐圈八卦', desc: '明星恋情、婚变、争议全收录', count: '3280+', icon: 'ri-star-line' },
  { title: '网红黑料', desc: '主播、博主不当行为大起底', count: '2150+', icon: 'ri-user-smile-line' },
  { title: '综艺内幕', desc: '真人秀背后的真实故事', count: '1560+', icon: 'ri-tv-line' },
  { title: '影视动态', desc: '剧组秘闻、选角争议追踪', count: '1890+', icon: 'ri-film-line' },
  { title: '音乐圈瓜田', desc: '歌手抄袭、翻车事件合集', count: '1240+', icon: 'ri-music-line' },
  { title: '直播圈风云', desc: '带货翻车、主播撕逼全纪录', count: '980+', icon: 'ri-live-line' },
  { title: '社会热点', desc: '引发全民讨论的热门事件', count: '2750+', icon: 'ri-fire-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            专题分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            七大板块，总有一款瓜适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group bg-background-50 border border-background-200/50 rounded-xl p-5 md:p-6 hover:border-primary-200/50 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 mb-3">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">
                {item.count} 条内容
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}